<div class="container">
    <h1 mat-dialog-title class="text-center">Transponder Operations</h1>
    <mat-dialog-content>
        <p><strong>Are you sure you want to perform {{action}}?</strong></p>
    </mat-dialog-content>
    <div class="d-flex justify-content-center">
        <mat-dialog-actions>
            <button mat-raised-button color="primary" mat-dialog-close>Cancel</button>
            <button type="button" mat-raised-button (click)="operations()">Ok</button>
        </mat-dialog-actions>
    </div>
<mat-spinner *ngIf="spinner"></mat-spinner>
</div>
